import { typographyPx } from './typographyPx';
import { typographyRem } from './typographyRem';
export var dynamicTypography = function (useRem) { return (useRem ? typographyRem : typographyPx); };
